import { createClient } from '@supabase/supabase-js';
// Use Vite's import.meta.env
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
// console.log('Supabase URL:', supabaseUrl ? 'Set' : 'Not set')
// console.log('Supabase Anon Key:', supabaseAnonKey ? 'Set' : 'Not set')
// Create client only if both variables exist
export const supabase = supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;
// console.log('Supabase client:', supabase ? 'Created' : 'Null')
